import { render, staticRenderFns } from "./HealthAndConfidentialityStatement.vue?vue&type=template&id=07a0b8d5&scoped=true&"
import script from "./HealthAndConfidentialityStatement.vue?vue&type=script&lang=js&"
export * from "./HealthAndConfidentialityStatement.vue?vue&type=script&lang=js&"
import style0 from "./HealthAndConfidentialityStatement.vue?vue&type=style&index=0&id=07a0b8d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0b8d5",
  null
  
)

export default component.exports